<template>
  <a :style="addStyle" class="c-btn c-btn--red" @click="$emit('button-click')">
    <div v-if="icon" class="c-icon c-icon--white u-wh24 c-icon--alpha50">
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <use v-bind="{'xlink:href': icon}" />
      </svg>
    </div>
    <p class="c-btn__text">{{ text }}</p>
  </a>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      require: true,
    },
    icon: {
      type: String,
      require: false,
    },
    addStyle: {
      type: String,
      require: false,
    },
  },
  emits: ["button-click"],
};
</script>
